import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-69ffc2c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tvc",
  autoplay: "",
  loop: "",
  controls: "",
  poster: "https://bpk-bucket-prod.oss-cn-beijing.aliyuncs.com/static/home/newUser/bodypark-video-cover-img.png",
  preload: "auto",
  "webkit-playsinline": "true",
  playsinline: "true",
  "x-webkit-airplay": "true",
  "x5-video-player-type": "h5",
  "x5-video-player-fullscreen": "true",
  "x5-video-ignore-metadata": "true",
  "x5-video-orientation": "landscape"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://bpk-bucket-prod.oss-cn-beijing.aliyuncs.com/static/website/tvc-long.mp4",
  type: "video/mp4"
}, null, -1));

const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("video", _hoisted_1, _hoisted_3);
}